import { forwardRef } from 'react';

import { StyledOnboardingImage, StyledOnboardingImageContainer } from './styles';

export const SamOnboardingImage = forwardRef<SVGSVGElement>((props, ref) => {
  return (
    <StyledOnboardingImageContainer>
      <StyledOnboardingImage
        width="297"
        height="305"
        viewBox="0 0 297 305"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
      >
        <g filter="url(#filter0_d_3850_80835)">
          <rect x="6" y="3" width="285" height="294" rx="6" fill="white" />
          <rect
            x="6.42939"
            y="3.42939"
            width="284.141"
            height="293.141"
            rx="5.57061"
            stroke="#ECECEC"
            strokeWidth="0.858789"
          />
          <rect x="28.2949" y="23.3601" width="173.52" height="4.84694" rx="2.42347" fill="#D1DEFF" />
          <rect x="26.6099" y="52.207" width="243.778" height="221.99" rx="5.15274" fill="#F5F9FD" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M63.7107 77.0075L65.2475 73.6264L68.6286 72.0896L65.2475 70.5527L63.7107 67.1716L62.1738 70.5527L58.7927 72.0896L62.1738 73.6264L63.7107 77.0075ZM63.7107 84.3843L62.1738 87.7654L58.7927 89.3023L62.1738 90.8391L63.7107 94.2202L65.2475 90.8391L68.6286 89.3023L65.2475 87.7654L63.7107 84.3843ZM51.4155 70.8601L54.4892 77.6223L61.2514 80.696L54.4892 83.7697L51.4155 90.5319L48.3418 83.7697L41.5796 80.696L48.3418 77.6223L51.4155 70.8601ZM51.4155 84.5935L52.6327 81.9132L55.313 80.696L52.6327 79.4788L51.4155 76.7985L50.1983 79.4788L47.518 80.696L50.1983 81.9132L51.4155 84.5935Z"
            fill="url(#paint0_radial_3850_80835)"
          />
          <rect x="86.458" y="67.2939" width="158.98" height="5.81633" rx="2.90816" fill="#D1DEFF" />
          <rect x="86.458" y="77.9551" width="158.98" height="5.81633" rx="2.90816" fill="#D1DEFF" />
          <rect x="86.458" y="88.6191" width="158.98" height="5.81633" rx="2.90816" fill="#D1DEFF" />
          <g filter="url(#filter1_d_3850_80835)">
            <rect x="76.7295" y="109.946" width="171.401" height="145.727" rx="7.41887" fill="white" />
          </g>
          <path d="M92.8477 234.551H231.76" stroke="#D2DAE6" strokeWidth="0.511646" />
          <path
            d="M135.898 164.341C135.898 163.21 136.815 162.294 137.945 162.294H157.117C158.247 162.294 159.164 163.21 159.164 164.341V234.998H135.898V164.341Z"
            fill="#AAC2FF"
          />
          <path
            d="M107.786 190.512C107.786 189.382 108.702 188.465 109.833 188.465H129.005C130.135 188.465 131.051 189.382 131.051 190.512V234.027H107.786V190.512Z"
            fill="#AAC2FF"
          />
          <path
            d="M193.092 178.882C193.092 177.752 194.008 176.835 195.138 176.835H214.311C215.441 176.835 216.357 177.752 216.357 178.882V234.029H193.092V178.882Z"
            fill="#AAC2FF"
          />
          <path
            d="M164.979 141.075C164.979 139.944 165.896 139.028 167.026 139.028H186.198C187.329 139.028 188.245 139.944 188.245 141.075V234.997H164.979V141.075Z"
            fill="#3E74FE"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3850_80835"
            x="0.847265"
            y="0.423632"
            width="295.305"
            height="304.305"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.57637" />
            <feGaussianBlur stdDeviation="2.57637" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.054902 0 0 0 0 0.117647 0 0 0 0 0.243137 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3850_80835" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3850_80835" result="shape" />
          </filter>
          <filter
            id="filter1_d_3850_80835"
            x="70.7432"
            y="104.983"
            width="183.374"
            height="157.699"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.02329" />
            <feGaussianBlur stdDeviation="2.99313" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.564394 0 0 0 0 0.688037 0 0 0 0 1 0 0 0 0.33 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3850_80835" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3850_80835" result="shape" />
          </filter>
          <radialGradient
            id="paint0_radial_3850_80835"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(67.5766 68.2501) scale(25.5816 45.3627)"
          >
            <stop stopColor="#02C79E" />
            <stop offset="0.17" stopColor="#03C2A2" />
            <stop offset="0.37" stopColor="#06B4AF" />
            <stop offset="0.59" stopColor="#0B9CC4" />
            <stop offset="0.81" stopColor="#127BE1" />
            <stop offset="1" stopColor="#195AFE" />
          </radialGradient>
        </defs>
      </StyledOnboardingImage>
    </StyledOnboardingImageContainer>
  );
});
